import StorageItem from "./StorageItem";
import StorageInterface from "./interfaces/StorageInterface";

const TTL = 3600 * 1000;

export default new class TtlLocalStorage implements StorageInterface {
    private storage: Storage;

    private ttl: number = TTL;

    constructor() {
        if (!this.isLocalStorageSupported()) {
            throw new Error('Your environment doesn\'t support local storage');
        }
        this.storage = localStorage;
    }

    public getItem(key: string): string | null {
        let data = this.storage.getItem(key);
        if (data !== null) {
            let item = StorageItem.fromString(data);
            if (!item.isExpired()) {
                return item.getValue();
            }
            this.removeItem(key);
        }
        return null;
    }

    public setItem(key: string, value: string): void {
        let item = new StorageItem(value, this.getExpiresAt());
        this.storage.setItem(key, item.serialize());
    }

    public removeItem(key: string): void {
        this.storage.removeItem(key);
    }

    public clear(): void {
        this.storage.clear();
    }

    protected getExpiresAt(): number {
        return (new Date()).getTime() + this.ttl;
    }

    protected isLocalStorageSupported(): boolean {
        let mod = 'modernizr';
        try {
            localStorage.setItem(mod, mod);
            localStorage.removeItem(mod);
            return true;
        } catch (e) {
            return false;
        }
    }
}


// WEBPACK FOOTER //
// ./src/common/persistedState/storage/Storage.ts